import { Link } from "react-router-dom";
import { eyeOpenSvg, pdfOutlineSvg } from "../../assets/imageImport";
import { ImageWithDefault } from "./imageWithDefault";
import { Fragment } from "react";

export const NewProductCategoryGrid = ({ row }) => {
  if (row) {
    return (
      <Fragment>
        <div className="col-6 col-sm-4 col-md-3 col-lg-3 mb-3 mt-3 mb-md-3" key={row.categoryId}>
          <div className="card catalogue-card">
            <Link to={row.categoryUrl ?? row.url} className="catalogue-img">
              {/* No trailing semicolon: a `;` inside a CSS *value* is invalid, so the browser
                  dropped the whole declaration and no border ever rendered. Inline (not custom.css)
                  because the `.catalogue-card .catalogue-img img` rule there sets `border: none`
                  for every catalogue card and row - this border is meant for this grid only. */}
              <ImageWithDefault
                style={{ border: "1px solid #d2d2d2" }}
                src={row.categoryImage ?? row.image}
                className="customize-img"
                alt="sub category"
              />
            </Link>
            <div className="card-body">
              <h5 className="card-title">
                <Link to={row.categoryUrl ?? row.url}>{row.categoryName}</Link>
              </h5>
              <p className="card-text" style={{ height: "35px" }}>
                {row.description ?? " "}
              </p>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
};
